export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Est-ce un produit physique ?',
    answer: 'Non. ATLAS VISUEL DE RADIOLOGIE PRO™ est un système 100 % numérique au format PDF, lisible sur ordinateur, tablette ou téléphone.',
  },
  {
    question: 'À qui s’adresse-t-il ?',
    answer:
      'Aux manipulateurs en électroradiologie médicale, aux étudiants en DE MERM et DTS IMRT, aux étudiants en médecine et aux internes qui veulent structurer leur lecture des images.',
  },
  {
    question: 'Quelles modalités sont traitées ?',
    answer:
      'La radiographie conventionnelle et numérique, le scanner (TDM), l’IRM, l’échographie et le Doppler, avec leurs principes d’acquisition, leur qualité d’image et leurs artefacts.',
  },
  {
    question: 'Est-ce un cours théorique ?',
    answer:
      'Non. C’est une bibliothèque visuelle prête à consulter : planches annotées, comparaisons normal / anormal, check-lists, protocoles de référence et cas pédagogiques, avec la méthode REPÉRER › ANALYSER › COMPARER › CONCLURE.',
  },
  {
    question: 'Le manipulateur va-t-il apprendre à poser un diagnostic ?',
    answer:
      'Non. L’interprétation diagnostique relève du médecin radiologue. L’atlas vous apprend à reconnaître, décrire et signaler une image inhabituelle selon vos responsabilités professionnelles.',
  },
  {
    question: 'Les doses et protocoles sont-ils chiffrés ?',
    answer:
      'Les principes de radioprotection sont expliqués ; les valeurs de dose et les paramètres précis suivent toujours les protocoles de l’établissement et les NRD en vigueur.',
  },
  {
    question: 'Les images sont-elles des images de patients ?',
    answer:
      'Non. Les images sont des illustrations pédagogiques et les cas sont des cas pédagogiques fictifs.',
  },
  {
    question: 'Que contiennent les 5 bonus ?',
    answer:
      'Guide d’anatomie radiologique en coupes, guide normal vs anormal, décodeur des densités scanner et des séquences IRM, check-lists de lecture et de contrôle qualité, cahier d’exercices de reconnaissance.',
  },
  {
    question: 'Est-ce une certification ou une formation qualifiante ?',
    answer:
      'Non. C’est un support pédagogique. Il ne remplace ni la formation, ni l’interprétation par le médecin radiologue, ni les protocoles de l’établissement.',
  },
  {
    question: 'Comment vais-je recevoir le produit ?',
    answer: 'Vous recevez l’accès numérique immédiatement après l’achat, par e-mail.',
  },
]
